import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Tab } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiOutlineEdit } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const MonthlyPromotions = () => {
  const [editData, setEditData] = useState({});
  
  // Form states
  const [day, setDay] = useState("");
  const [prizeValue, setPrizeValue] = useState("");
  const [prizeType, setPrizeType] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [rewardType, setRewardType] = useState("");
  const [isSpecial, setIsSpecial] = useState("");
  const [occasion, setoccasion] = useState("");
  const [multiplier, setMultiplier] = useState("");
  const[boosterValue,setBoosterValue]=useState("");
  const[freespinValue,setFreespinValue]=useState("");
  // Multi-reward per day: any combination of SC + GC + Free Spins + Booster
  const [scChecked, setScChecked] = useState(false);
  const [gcChecked, setGcChecked] = useState(false);
  const [fsChecked, setFsChecked] = useState(false);
  const [boosterChecked, setBoosterChecked] = useState(false);
  const [boosterPackageId, setBoosterPackageId] = useState("");
  const [scValue, setScValue] = useState("");
  const [gcValue, setGcValue] = useState("");
  const [openconfig, setOpenconfig] = useState(false);
  const[configlist,setConfiglist]=useState([]);
  const[packagelist,setPackagelist]=useState([]);
  const [minpackage,setMinpackage]=useState("");
  const[retainpacakage,setRetainpackage]=useState("");
  const[minpkvalue,setMinpkvalueValue]=useState("");
  const[retainpkvalue,setRetainpkValue]=useState("");
  const [streakConfigs, setStreakConfigs] = useState([]);

  const [promotionType, setPromotionType] = useState(4);
  const dayCount = streakConfigs.find(config => config.id === promotionType)?.streak || 30;

  // Table states
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    setShow(false);
    setEditData({});
  }
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchStreakConfigs();
  }, []);

  useEffect(() => {
    fetchMonthlyPromotions();
    setPage(0);
  }, [promotionType]);

  const fetchStreakConfigs = async () => {
    try {
      const response = await getAllData(endPoints.api.GET_STREAK_TYPES);
      const records = Array.isArray(response) ? response : response?.data;
      if (records && records.length > 0) {
        setStreakConfigs(records);
        setPromotionType(records[0].id);
      }
    } catch (error) {
      console.error("Error fetching streak configs:", error);
    }
  };

  const fetchMonthlyPromotions = async () => {
    setIsLoading(true);
    try {
      const url = `${endPoints.api.MONTHLY_REWARDS}/${promotionType}`
      const response = await getAllData(url);
      if(response.status == "success"){
        setRows(response?.data);
      }
      else{
        ErrorToast("Failed to fetch monthly promotions data");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOk = async () => {
    const sc = scChecked ? Number(scValue) || 0 : 0;
    const gc = gcChecked ? Number(gcValue) || 0 : 0;
    const freeSpin = fsChecked ? Number(freespinValue) || 0 : 0;
    const booster = boosterChecked ? Number(boosterValue) || 0 : 0;

    if (!day) { ErrorToast("Please select a day"); return; }
    if (scChecked && sc <= 0) { ErrorToast("Enter a Sweeps Coins amount greater than 0"); return; }
    if (gcChecked && gc <= 0) { ErrorToast("Enter a Gold Coins amount greater than 0"); return; }
    if (fsChecked && freeSpin <= 0) { ErrorToast("Enter a Free Spins count greater than 0"); return; }
    if (boosterChecked && (booster <= 0 || booster > 100)) { ErrorToast("Booster must be between 1 and 100 (%)"); return; }
    if (sc <= 0 && gc <= 0 && freeSpin <= 0 && booster <= 0) {
      ErrorToast("Select at least one reward with a value greater than 0");
      return;
    }
    // representative reward_type (kept for display + backend enum validation)
    let repType = "SAGA_COIN";
    if (sc > 0) repType = "SAGA_COIN";
    else if (gc > 0) repType = "GOLD_COIN";
    else if (freeSpin > 0) repType = "FREE_SPIN";
    else if (booster > 0) repType = "BOOSTER";

    setIsLoading(true);
    const url = `${endPoints.api.UPDATE_MONTHLY_REWARDS}`;
    const payload = {
      id: editData.id,
      promotionType: promotionType,
      dayNumber: Number(day),
      rewardType: repType,
      rewardValue: 0,
      sc_coin: sc,
      gc_coin: gc,
      freeSpin: freeSpin,
      booster: booster,
      packageId: boosterChecked && boosterPackageId ? boosterPackageId : null,
      title: title,
      description: description,
      isSpecial: isSpecial == "Yes" ? true : false,
      active: true,
      occasion: occasion,
      multiplier: multiplier ? Number(multiplier) : 1,
    };
    try{
    const response =  await addData(url, payload);
    if(response?.data?.status == "success"){
      SuccesToast("monthly promotion updated successfully");
      fetchMonthlyPromotions();
      return; 
    }
    else{
      ErrorToast(response?.message || "Failed to update monthly promotion");
    }
   }
    catch(error){
      console.error("Error updating monthly promotion:", error);
      ErrorToast("Error updating monthly promotion");
    }finally{
      setIsLoading(false);
      handleClose();
    }
  };

  useEffect(() => {
    if (editData?.id) {
      setDay(editData.dayNumber || "");
      setTitle(editData.title || "");
      setDescription(editData.description || "");
      setRewardType(editData.rewardType || "");
      setIsSpecial(editData.isSpecial ? "Yes" : "No");
      setoccasion(editData.occasion || "");
      setMultiplier(editData.multiplier || "");

      const sc = Number(editData.sc) || 0;
      const gc = Number(editData.gc) || 0;
      const fs = Number(editData.freeSpin) || 0;
      const booster = Number(editData.booster) || 0;
      setScChecked(sc > 0);  setScValue(sc > 0 ? sc : "");
      setGcChecked(gc > 0);  setGcValue(gc > 0 ? gc : "");
      setFsChecked(fs > 0);  setFreespinValue(fs > 0 ? fs : "");
      setBoosterChecked(booster > 0);  setBoosterValue(booster > 0 ? booster : "");
      if (booster > 0 && !editData.packageId) {
        // legacy row (created before per-package boosters): dropdown has no blank
        // option anymore, so default it to the first daily-streak package to keep
        // what's shown in sync with what would actually be saved on Update.
        const dailyStreakPackages = packagelist.filter((pkg) => pkg?.dailyStreak);
        setBoosterPackageId(dailyStreakPackages[0]?.id || "");
      } else {
        setBoosterPackageId(editData.packageId || "");
      }
    }
  }, [editData]);

const getconfigList = async () => {
    setIsLoading(true); 
    try {
      const url = `${endPoints.api.GET_MONTHLY_REWARD_CONFIG}`;
      const response = await getAllData(url);
      if(response.status == "success"){
        setConfiglist(response?.data);
        setMinpackage(response?.data[0]?.min_pk_id || "");
        setRetainpackage(response?.data[0]?.max_pk_id || "");
        setMinpkvalueValue(response?.data[0]?.minPackageAmount || "");
        setRetainpkValue(response?.data[0]?.maxPackageAmount || "");
      }
      else{
        console.log("Failed to fetch monthly promotion configuration");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      getconfigList();
      getCoinPackageList();
  }, []);

    const getCoinPackageList = async (list) => {
      let url = `${endPoints.api.GET_PACKAGE}`;
  
      await getAllData(url)
        .then((response) => {
          if (response.status == "success" && response?.data?.length > 0) {
            const filteredPackageData = response?.data?.filter(
              (item) => item.isactive === 1
            );
            setPackagelist(filteredPackageData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const handleConfigUpdate = async () => {
      setIsLoading(true);
      const url = `${endPoints.api.MONTHLY_REWARD_CONFIG}`;
      const payload = {
        minPackageAmount: minpkvalue || "",
        maxPackageAmount: retainpkvalue || "",
        min_pk_id: minpackage,
        max_pk_id: retainpacakage,
        packageType: "UNLOCK",
        description: "Monthly Promotion Package Configuration",
        isActive: true,
        id:0,
      };
      try{
      const response =  await addData(url, payload);
      if(response?.data?.status == "success"){
        SuccesToast("monthly promotion configuration updated successfully");
        getconfigList();
        return; 
      } 
      else{
        ErrorToast(response?.message || "Failed to update monthly promotion configuration");
      }
      }
      catch(error){
        console.error("Error updating monthly promotion configuration:", error);
        ErrorToast("Error updating monthly promotion configuration");
      }
      finally{
        setIsLoading(false);
        setOpenconfig(false);
      }
    };

  return (
    <>
      <Toaster />
      {isLoading && <Loader />}
      <div className="inner-space12">
        <div className="row">
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #444",
              marginLeft:"15px",
              marginTop:"5px",
              marginRight:"15px",
              paddingRight:"50px",
            }}
          >
            <h3
              className="mb-2 mt-2"
              style={{ fontFamily: "ArticulatCF-Bold" }}
            >
              Promotions
            </h3>

            <Form.Select
              value={promotionType}
              onChange={(event) => setPromotionType(Number(event.target.value))}
              style={{ width: "180px", marginTop: "8px", marginBottom: "8px" }}
            >
              {streakConfigs.map((config) => (
                <option key={config.id} value={config.id}>
                  {config.streak} Day Promotion
                </option>
              ))}
            </Form.Select>

            {/* <button
              className="btn btn-primary mb-2 mt-2"
              style={{ backgroundColor: "#04631e", borderColor: "#04631e" }}
              onClick={() => {
                setOpenconfig(true);
              }}
            >
              Promotion Configuration
            </button> */}

          </div>
        </div>

        <div className="container-fluid table-custom">
          <div className="row" style={{ padding: "10px"}}>
            <div className="col-md-12">
              <TableContainer component={Paper} style={{overflowX:"hidden"}}>
                <Table
                  className="c_table"
                  size="small"
                  aria-label="Monthly promotions table"
                  stickyHeader
                  sx={{ minWidth: 500 }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Day</TableCell>
                      <TableCell align="center">Title</TableCell>
                      <TableCell align="center">Description</TableCell>
                      <TableCell align="center">SC</TableCell>
                       <TableCell align="center">GC</TableCell>
                       <TableCell align="center">Free Spins</TableCell>
                       <TableCell align="center">Booster(%)</TableCell>
                       <TableCell align="center">Multiplier</TableCell>
                       <TableCell align="center">Special Reward</TableCell>
                       <TableCell align="center">Occasion</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? rows.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : rows
                    ).map((row, index) => (
                      <TableRow
                        key={row.id || index}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align="center"> {row?.dayNumber}</TableCell>
                        <TableCell align="center">
                          {row?.title}
                        </TableCell>
                        <TableCell align="center">
                          {row?.description}
                        </TableCell>
                        <TableCell align="center">{row?.sc_coin > 0 ? row?.sc_coin : "-"}</TableCell>
                        <TableCell align="center">{row?.gc_coin > 0 ? row?.gc_coin : "-"}</TableCell>
                        <TableCell align="center">{row?.freeSpin > 0 ? row?.freeSpin : "-"}</TableCell>
                        <TableCell align="center">{row?.booster > 0 ? row?.booster : "-"}</TableCell>
                        <TableCell align="center">{row?.multiplier}</TableCell>
                        <TableCell align="center">{row?.isSpecial ? "Yes" : "No"}</TableCell>
                        <TableCell align="center">{row?.occasion}</TableCell>
                        <TableCell align="center">
                          <div className="row">
                            <div className="col-12">
                              <AiOutlineEdit
                                size={20}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditData(row);
                                  setShow(true);
                                }}
                              />
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={5} />
                      </TableRow>
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[
                          5,
                          10,
                          25,
                          // { label: "All", value: -1 },
                        ]}
                        colSpan={5}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                          inputProps: {
                            "aria-label": "rows per page",
                          },
                          native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>

        <Modal
          className="modal-md modal-dialog-centered"
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          dialogClassName="custom-modal-center"
        >
          <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Monthly Promotion
          </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="day">
                  <Form.Label>Day</Form.Label>
                  <Form.Select 
                    value={day} 
                    onChange={(event) => setDay(event.target.value)}
                  >
                    <option value="">Select Day</option>
                    {Array.from({length: dayCount}, (_, i) => (
                      <option key={i + 1} value={i + 1}>Day {i + 1}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="prizeValue">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}   
                    />
                </Form.Group>
              </div>

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}   
                    />
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Label>Rewards for this day (select any combination)</Form.Label>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <Form.Check
                      type="checkbox"
                      id="reward-sc"
                      label="Sweeps Coins (SC)"
                      checked={scChecked}
                      onChange={(e) => setScChecked(e.target.checked)}
                    />
                    {scChecked && (
                      <Form.Control
                        type="number"
                        min="0"
                        className="mt-1"
                        placeholder="SC amount"
                        value={scValue}
                        onChange={(e) => setScValue(e.target.value)}
                      />
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <Form.Check
                      type="checkbox"
                      id="reward-gc"
                      label="Gold Coins (GC)"
                      checked={gcChecked}
                      onChange={(e) => setGcChecked(e.target.checked)}
                    />
                    {gcChecked && (
                      <Form.Control
                        type="number"
                        min="0"
                        className="mt-1"
                        placeholder="GC amount"
                        value={gcValue}
                        onChange={(e) => setGcValue(e.target.value)}
                      />
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <Form.Check
                      type="checkbox"
                      id="reward-fs"
                      label="Free Spins"
                      checked={fsChecked}
                      onChange={(e) => setFsChecked(e.target.checked)}
                    />
                    {fsChecked && (
                      <Form.Control
                        type="number"
                        min="0"
                        className="mt-1"
                        placeholder="Free spin count"
                        value={freespinValue}
                        onChange={(e) => setFreespinValue(e.target.value)}
                      />
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <Form.Check
                      type="checkbox"
                      id="reward-booster"
                      label="Booster (%)"
                      checked={boosterChecked}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setBoosterChecked(checked);
                        if (checked && !boosterPackageId) {
                          const dailyStreakPackages = packagelist.filter((pkg) => pkg?.dailyStreak);
                          setBoosterPackageId(dailyStreakPackages[0]?.id || "");
                        }
                      }}
                    />
                    {boosterChecked && (
                      <>
                        <Form.Control
                          type="number"
                          min="0"
                          max="100"
                          className="mt-1"
                          placeholder="Booster %"
                          value={boosterValue}
                          onChange={(e) => setBoosterValue(e.target.value)}
                        />
                        <Form.Select
                          className="mt-1"
                          value={boosterPackageId}
                          onChange={(e) => setBoosterPackageId(e.target.value)}
                        >
                          {packagelist
                            .filter((pkg) => pkg?.dailyStreak)
                            .map((pkg) => (
                              <option key={pkg.id} value={pkg.id}>
                                ${pkg.purchase_price}
                              </option>
                            ))}
                        </Form.Select>
                      </>
                    )}
                  </div>
                </div>
              </div>

               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="rewardType">
                  <Form.Label>multiplier</Form.Label>
                  <Form.Select 
                    value={multiplier} 
                    onChange={(event) => setMultiplier(event.target.value)}
                  >
                    <option value="">Select Multiplier</option>
                    <option value="1">1x</option>
                    <option value="2">2x</option>
                    <option value="3">3x</option>
                    <option value="4">4x</option>
                    <option value="5">5x</option>
                  </Form.Select>
                </Form.Group>
              </div>


               <div className="col-md-6">
                <Form.Group className="mb-3" controlId="prizeValue">
                  <Form.Label>occasion</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter occasion"
                    value={occasion}
                    onChange={(e) => setoccasion(e.target.value)}   
                    />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="isSpecial">
                  <Form.Label>Special Reward</Form.Label>
                  <Form.Select 
                    value={isSpecial} 
                    onChange={(event) => setIsSpecial(event.target.value)}
                  >
                    <option value="">Select isSpecial</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Select>
                </Form.Group>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleOk}
              style={{
                background: "#04631e",
                borderColor: "#04631e",
              }}
            >
              Update Promotion
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="modal-md modal-dialog-centered"
          show={openconfig}
          onHide={() => setOpenconfig(false)}
          size="lg"
          centered
          dialogClassName="custom-modal-center"
        >
          <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">  
            Monthly Promotion Configuration
          </Modal.Title>
          </Modal.Header> 
          <Modal.Body>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3" controlId="day">
                  <Form.Label>Minimum Pacakge</Form.Label>
                  <Form.Select 
                    value={minpackage} 
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      setMinpackage(selectedId);
                      const selectedPackage = packagelist.find(pkg => pkg?.id == selectedId);
                      setMinpkvalueValue(selectedPackage?.purchase_price);
                    }}
                  >
                    <option value="">Select Pacakge</option>
                    {/* {Array.from({length: 30}, (_, i) => (
                      <option key={i + 1} value={i + 1}>Day {i + 1}</option>
                    ))} */}
                    {packagelist.map((item) => (
                      <option key={item?.id} value={item?.id}>${item?.purchase_price}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-12">
                <Form.Group className="mb-3" controlId="day">
                  <Form.Label>Retain Pacakge</Form.Label>
                  <Form.Select 
                    value={retainpacakage} 
                     onChange={(event) => {
                      const selectedId = event.target.value;
                       setRetainpackage(selectedId);
                      const selectedPackage = packagelist.find(pkg => pkg?.id == selectedId);
                      setRetainpkValue(selectedPackage?.purchase_price);
                    }}
                  >
                    <option value="">Select Pacakge</option>
                    {/* {Array.from({length: 30}, (_, i) => (
                      <option key={i + 1} value={i + 1}>Day {i + 1}</option>
                    ))} */}
                    {packagelist.map((item) => (
                      <option key={item?.id} value={item?.id}>${item?.purchase_price}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleConfigUpdate}
              style={{
                background: "#04631e",
                borderColor: "#04631e",
              }}
            >
              Update config
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    </>
  );
};

export default MonthlyPromotions;
